'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;
exports.load = load;
exports.infoSubmit = infoSubmit;
exports.merchantTypeChange = merchantTypeChange;
exports.addressInfo = addressInfo;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by Administrator on 2016/7/6.
 */
var LOAD = 'goeasy-crafts/merchantAuthentication/LOAD';
var LOAD_SUCCESS = 'goeasy-crafts/merchantAuthentication/LOAD_SUCCESS';
var LOAD_FAIL = 'goeasy-crafts/merchantAuthentication/LOAD_FAIL';

var SUBMIT = 'goeasy-crafts/merchantAuthentication/SUBMIT';
var SUBMIT_SUCCESS = 'goeasy-crafts/merchantAuthentication/SUBMIT_SUCCESS';
var SUBMIT_FAIL = 'goeasy-crafts/merchantAuthentication/SUBMIT_FAIL';

var GETADDRESS = 'goeasy-crafts/merchantAuthentication/GETADDRESS';
var GETADDRESS_SUCCESS = 'goeasy-crafts/merchantAuthentication/GETADDRESS_SUCCESS';
var GETADDRESS_FAIL = 'goeasy-crafts/merchantAuthentication/GETADDRESS_FAIL';

// MERCHANTTYPECHANGE, MERCHANTTYPECHANGE_SUCCESS, MERCHANTTYPECHANGE_FAIL
var MERCHANTTYPECHANGE = 'goeasy-crafts/merchantAuthentication/MERCHANTTYPECHANGE';
var MERCHANTTYPECHANGE_SUCCESS = 'goeasy-crafts/merchantAuthentication/MERCHANTTYPECHANGE_SUCCESS';
var MERCHANTTYPECHANGE_FAIL = 'goeasy-crafts/merchantAuthentication/MERCHANTTYPECHANGE_FAIL';
/*
 const GETPAYMENTINFO = 'goeasy-crafts/merchantAuthentication/GETPAYMENTINFO';
 const GETPAYMENTINFO_SUCCESS = 'goeasy-crafts/merchantAuthentication/GETPAYMENTINFO_SUCCESS';
 const GETPAYMENTINFO_FAIL = 'goeasy-crafts/merchantAuthentication/GETPAYMENTINFO_FAIL';

 const GETINFOBYORDERNUMBER = 'goeasy-crafts/merchantAuthentication/GETINFOBYORDERNUMBER';
 const GETINFOBYORDERNUMBER_SUCCESS = 'goeasy-crafts/merchantAuthentication/GETINFOBYORDERNUMBER_SUCCESS';
 const GETINFOBYORDERNUMBER_FAIL = 'goeasy-crafts/merchantAuthentication/GETINFOBYORDERNUMBER_FAIL';*/

var initialState = {
  info: {}
};

function analysisAddressInfo(data, result, level, passDefValue, currentValue) {
  var retrunValue = result;
  if (!passDefValue || passDefValue === '') {
    var addressInfoArray = [];
    var defValue = void 0;
    if (data.addressData.defValue instanceof Array) {
      defValue = [].concat((0, _toConsumableArray3.default)(data.addressData.defValue));
    } else {
      defValue = ['', '', '', ''];
    }
    if (result.addressData && result.addressData.one instanceof Array) {
      addressInfoArray = result.addressData.one;
    }

    var newData = {};

    if (data.addressData) {
      newData = (0, _extends3.default)({}, data.addressData);
    }

    newData[level] = addressInfoArray;

    if (level === 'one') {
      newData.two = [];
      newData.three = [];
      newData.four = [];
    } else if (level === 'two') {
      newData.three = [];
      newData.four = [];
      defValue[0] = currentValue;
    } else if (level === 'three') {
      newData.four = [];
      defValue[1] = currentValue;
    } else if (level === 'four') {
      defValue[2] = currentValue;
    }

    newData.defValue = defValue;

    retrunValue = newData;
  }
  return (0, _extends3.default)({}, data, { addressData: retrunValue });
}

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case MERCHANTTYPECHANGE:
      return (0, _extends3.default)({}, state, {
        changing: true
      });
    case MERCHANTTYPECHANGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        changing: false,
        changed: true,
        data: action.result
      });
    case MERCHANTTYPECHANGE_FAIL:
      return (0, _extends3.default)({}, state, {
        changing: false,
        changed: false
      });
    case SUBMIT:
      return (0, _extends3.default)({}, state, {
        submitting: true
      });
    case SUBMIT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: true
      });
    case SUBMIT_FAIL:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: false
      });
    /*
     case GETPAYMENTINFO:
     return {
     ...state,
     gettingPaymentInfo: true
     };
     case GETPAYMENTINFO_SUCCESS:
     return {
     ...state,
     gettingPaymentInfo: false,
     gottenPaymentInfo: true,
     paymentData: action.result
     };
     case GETPAYMENTINFO_FAIL:
     return {
     ...state,
     gettingPaymentInfo: false,
     gottenPaymentInfo: false,
     error: action.error
     };*/
    case GETADDRESS:
      return (0, _extends3.default)({}, state, {
        addressGetting: true
      });
    case GETADDRESS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        addressGetting: false,
        addressGotten: true,
        data: analysisAddressInfo(state.data, action.result, action.level, action.defValue, action.currentValue)
      });
    case GETADDRESS_FAIL:
      return (0, _extends3.default)({}, state, {
        addressGetting: false,
        addressGotten: false,
        data: null,
        error: action.error
      });
    /*
     case GETINFOBYORDERNUMBER:
     return {
     ...state,
     infoGetting: true,
     infoGotten: false
     };
     case GETINFOBYORDERNUMBER_SUCCESS:
     return {
     ...state,
     infoGetting: false,
     infoGotten: true,
     payInfoData: action.result
     };
     case GETINFOBYORDERNUMBER_FAIL:
     return {
     ...state,
     infoGetting: false,
     infoGotten: false,
     error: action.error
     };*/
    default:
      return state;
  }
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('/merchantAuthentication', {
        data: {
          type: 'getData'
        }
      });
    }
  };
}

function infoSubmit(info, orderNumber) {
  return {
    types: [SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/merchantAuthentication', {
        data: {
          type: 'infoSubmit',
          info: info,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function merchantTypeChange(info, orderNumber) {
  return {
    types: [MERCHANTTYPECHANGE, MERCHANTTYPECHANGE_SUCCESS, MERCHANTTYPECHANGE_FAIL],
    promise: function promise(client) {
      return client.post('/merchantAuthentication', {
        data: {
          type: 'merchantTypeChange',
          info: info,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function addressInfo(data, level) {
  return {
    types: [GETADDRESS, GETADDRESS_SUCCESS, GETADDRESS_FAIL],
    level: level,
    defValue: data.defValue,
    currentValue: data.value,
    promise: function promise(client) {
      return client.post('/publicInfo', {
        data: {
          type: 'getAddressInfo',
          data: data
        }
      });
    }
  };
}

/*
 export function getPaymentData(orderNumber) {
 return {
 types: [GETPAYMENTINFO, GETPAYMENTINFO_SUCCESS, GETPAYMENTINFO_FAIL],
 promise: (client) => client.post('/merchantAuthentication', {
 data: {
 type: 'getPaymentData',
 orderNumber
 }
 })
 };
 }

 export function getInfoByOrderNumber(orderNumber) {
 return {
 types: [GETINFOBYORDERNUMBER, GETINFOBYORDERNUMBER_SUCCESS, GETINFOBYORDERNUMBER_FAIL],
 promise: (client) => client.post('/merchantAuthentication', {
 data: {
 type: 'getDataByOrderNumber',
 orderNumber
 }
 })
 };
 }*/


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/merchantAuthentication.js
 ** module id = 625
 ** module chunks = 0
 **/